export default {"src":"/_next/static/media/AfterLogo.a304a8a3.svg","height":30,"width":104,"blurWidth":0,"blurHeight":0};